import { Checkbox } from 'primereact/checkbox';
import React from 'react';

interface FilterCheckBoxItemDatamodel {
  key: string;
  label: string;
  isChecked: boolean;
  onChange: () => void;
}

const styles = {
  checkboxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    direction: 'rtl' as const,
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
    },
  },
  selectedCheckboxItem: {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    fontWeight: 500,
    color: '#1976d2',
  },
  checkboxLabel: {
    flex: 1,
    cursor: 'pointer',
    userSelect: 'none' as const,
  },
};

export const FilterCheckBoxItem: React.FC<FilterCheckBoxItemDatamodel> = ({
  key,
  label,
  isChecked,
  onChange,
}) => (
  <div
    key={key}
    style={{
      ...styles.checkboxItem,
      ...(isChecked ? styles.selectedCheckboxItem : {}),
    }}
    onClick={onChange}
  >
    <Checkbox
      checked={isChecked}
      /*onChange={onChange}*/
      style={{
        color: isChecked ? '#1976d2' : undefined,
      }}
    />
    <label style={styles.checkboxLabel}>{label}</label>
  </div>
);
